import { Component, Input, AfterViewInit, ViewChild, HostListener } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material';
import { AgmMap } from '@agm/core';
import { isUndefined } from 'util';

import { Airport } from '../models/airport.model';


@Component({
  selector: 'app-chart-panel',
  templateUrl: './chart-panel.component.html',
  styleUrls: ['./chart-panel.component.scss']
})
export class ChartPanelComponent implements AfterViewInit {
  @Input() airport: Airport;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  @ViewChild('satelliteMap') myMap: AgmMap;
  selectedTab: MatTab;

  /**
   * Returns the diagram URL. This will either be a link to the full-size PDF diagram (if available), or the thumbnail
   * generated from terminal procedures.
   * @returns {string}
   */
  get diagramUrl(): string {
    const diagram = this.airport.diagram;
    if (diagram) {
      return diagram.url;
    }
    if (this.airport.hasThumbNail) {
      return this.airport.thumbNail;
    }
    return '';
  }

  ngAfterViewInit(): void {
    // Workaround to correctly set the initially selected tab. Wrapped in setTimeout to avoid triggering
    // change detection error ("Expression has changed after it was checked").
    setTimeout(() => {
      this.selectedTab = this._getSelectedTab();
    }, 0);
  }

  onSelectTab(event) {
    this.selectedTab = event.tab;
  }

  private _getSelectedTab(): MatTab {
    if (!this.tabGroup._tabs) {
      return null;
    }
    return this.tabGroup._tabs
      .toArray()
      .find((tab: MatTab, i: number) => i === this.tabGroup.selectedIndex);
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (!isUndefined(this.myMap)) {
      this.myMap.triggerResize()
        .then(() => (this.myMap as any)._mapsWrapper.setCenter({ lat: this.airport.location.lat, lng: this.airport.location.lon }));
    }
  }
}
